// import { useState } from 'react';
import Layout from '../components/layouts/Main';
import AddTenantForm from './form-components/AddTenantForm';
import ClientTable from "../components/ClientTable";
import { Link } from 'react-router-dom';

const Clients = () => {
    return (
        <Layout>
            <>
                <div>
                    <AddTenantForm />
                </div>
                <nav className="mb-3" aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <a href="#!">Pages</a>
                        </li>
                        <li className="breadcrumb-item active">Clients</li>
                    </ol>
                </nav>
                <h2 className="text-bold text-body-emphasis mb-5">Clients</h2>
                <div
                    id="clients"
                    data-list='{"valueNames":["customer","email","mobile_number","city","last_active","joined"],"page":10,"pagination":true}'
                >
                    <div className="row align-items-center justify-content-between g-3 mb-4">
                        <div className="col col-auto">
                            <div className="search-box">
                                <form className="position-relative">
                                    <input
                                        className="form-control search-input search"
                                        type="search"
                                        placeholder="Search tenants"
                                        aria-label="Search"
                                    />
                                    <span className="fas fa-search search-box-icon" />
                                </form>
                            </div>
                        </div>
                        <div className="col-auto">
                            <div className="d-flex align-items-center">
                                <button className="btn btn-link text-body me-4 px-0">
                                    <span className="fa-solid fa-file-export fs-9 me-2" />
                                    Export
                                </button>
                                <button
                                    className="btn btn-primary"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasAddTenant"
                                >
                                    <span className="fas fa-plus me-2" />
                                    Add Client
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="mx-n4 mx-lg-n6 px-4 px-lg-6 mb-9 bg-body-emphasis border-y mt-2 position-relative top-1">
 
                            <ClientTable />

                    </div>
                </div>
                
            </>

        </Layout>
    );
};

export default Clients;
